import { render, staticRenderFns } from "./Allcar.vue?vue&type=template&id=38a85639&scoped=true"
import script from "./Allcar.vue?vue&type=script&lang=js"
export * from "./Allcar.vue?vue&type=script&lang=js"
import style0 from "./Allcar.vue?vue&type=style&index=0&id=38a85639&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a85639",
  null
  
)

export default component.exports